import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-schedule-job-match-item-actions-modal',
    templateUrl: './schedule-job-match-item-actions-modal.component.html'
})
export class ScheduleJobMatchItemActionsModalComponent implements OnInit {
    modalData: any;
    actionType: any;
    actionLabel: any;
    public onClose: Subject<any>;

    constructor(
        private bsModalRef: BsModalRef,
        public bsModalService: BsModalService
    ) {
        this.onClose = new Subject();
        if (this.bsModalService.config.initialState) {
            this.modalData = this.bsModalService.config.initialState;
            this.actionType = this.modalData.actionType;
            this.actionLabel = this.modalData.actionLabel;
        }
    }

    ngOnInit(): void {
    }

    closeModal(data?: any): void {
        this.onClose.next(data);
        this.bsModalRef.hide();
    }

    dismissModal(): void {
        this.closeModal(null);
    }

    onEmployeeAdded(event: any): void {
        if (event && event.employee) {
            this.closeModal({ callbackType: this.actionType, entity: event.employee });
        } else {
            this.dismissModal();
        }
    }
}
